import TimeLayout from "../layouts/TimeLayout";

const Time = () => {
  return (
    <div className="p-8">
      <TimeLayout />
    </div>
  );
};

export default Time;
